import { TextField } from "@mui/material";
import { type FieldErrors, type UseFormRegister } from "react-hook-form";

import { type CredentialsFormData } from "../api/schema";

interface TimeclockComplianceCredentialsProps {
  register: UseFormRegister<CredentialsFormData>;
  errors: FieldErrors<CredentialsFormData>;
}

export function TimeclockComplianceCredentials({
  register,
  errors,
}: TimeclockComplianceCredentialsProps) {
  return (
    <TextField
      fullWidth
      label="Time Clock Pin"
      error={!!errors.timeclockPin}
      helperText={errors.timeclockPin?.message}
      {...register("timeclockPin")}
    />
  );
}
